<template>
  <DiseaseModal
    :value="isDialogOpened"
    is-back
    :title="t('Что лечит врач', options)"
    :placeholder="t('Заболевание', options)"
    :page-type="pageType"
    :town-id="filtersStore.filters.visitLocation === 'online' ? undefined : commonStore.town.id"
    :speciality-id="filtersStore.filters.speciality.id"
    :selected-disease="filtersStore.unsavedFilters.disease"
    @disease:selected="onClickDisease"
    @disease:reset="onReset"
    @input="handleCloseModal"
  >
    <template #footer>
      <BtnShowDoctors
        :active="isDialogOpened"
        class="pa-2 elevation-8"
        @click:submit="applySelectedDisease"
        @click:close="closeDialog"
      />
    </template>
  </DiseaseModal>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import I18NextVue from 'i18next'
import { dispatchCustomEventGlobally } from 'www/utils'
import useChipsStore from 'www/vue_components/common/TheFilters/doctors/stores/useChipsStore'
import useCommonStore from 'www/vue_components/common/TheFilters/doctors/stores/useCommonStore'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'
import useDialogManager from 'www/vue_components/common/mixins/DialogManager/useDialogManager'
import updateDoctorListPage from 'www/vue_components/common/TheFilters/doctors/functions/updateDoctorListPage'
import { EVENTS as SNACKBAR_EVENTS } from 'www/vue_components/common/core/SnackbarNotification/constants'
import DiseaseModal from 'www/vue_components/common/TheFilters/doctors/components/DiseaseFilters/components/DiseaseModal.vue'
import BtnShowDoctors from 'www/vue_components/common/TheFilters/doctors/components/BtnShowDoctors/BtnShowDoctors.vue'
import type { ApiDiseaseParamsGet } from 'www/vue_components/common/TheFilters/doctors/api/apiDiseases.types'
import type { Filters } from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore.types'

const chipsStore = useChipsStore()
const commonStore = useCommonStore()
const filtersStore = useFiltersStore()
const { isDialogOpened, openDialog, closeDialog } = useDialogManager('DiseaseFilters')

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const pageType = computed<ApiDiseaseParamsGet['page_type']>(() => {
  if (filtersStore.filters.visitLocation === 'online') {
    return 'online_doctor_list'
  }

  if (filtersStore.filters.visitLocation === 'home') {
    return 'house_doctor_list'
  }

  return 'town_doctor_list'
})

const onReset = async () => {
  closeDialog()
  filtersStore.updateFilters({ disease: undefined })

  await updateDoctorListPage()

  dispatchCustomEventGlobally(SNACKBAR_EVENTS.open, {
    upper: true,
    message: t('Фильтр сброшен', options.value),
  })
}

watch(
  () => filtersStore.filters.disease,
  () => {
    chipsStore.updateDiseaseChip({
      name: filtersStore.filters.disease?.name || '',
      isActive: !!filtersStore.filters.disease,
      isVisible: !!filtersStore.filters.disease,
      truncate: true,
      onClick: openDialog,
      onReset,
    })
  },
  { immediate: true },
)

const onClickDisease = (disease: Filters['disease']) => {
  filtersStore.updateUnsavedFilters({ disease })
}

function applySelectedDisease() {
  closeDialog()
  filtersStore.applyUnsavedFilters()
  updateDoctorListPage()
}

function handleCloseModal() {
  closeDialog()
  filtersStore.resetUnsavedFilters()
}
</script>
